module.exports = __webpack_public_path__ + "img/ice_hotwallet.gm.fa15e10.png";